import React from 'react';
import styled from 'styled-components';
import GameModeVariants, { GameModeConfig } from './GameModeVariants';

interface AdvancedGameModesProps {
  onBackToMenu: () => void;
  onStartGame: (mode: GameModeConfig) => void;
}

const Container = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
`;

const Header = styled.div`
  text-align: center;
  color: white;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  margin: 0 0 6px 0;
`;

const Subtitle = styled.p`
  margin: 0;
  opacity: 0.9;
`;

const Card = styled.div`
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(8px);
  border-radius: 12px;
  padding: 16px;
  color: white;
  
  /* Make inner grid allow two columns on wider screens */
  & > div {
    width: 100%;
  }
`;

const Footer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
`;

const BackButton = styled.button`
  background: #757575;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  
  &:hover { background: #616161; }
`;

const AdvancedGameModes: React.FC<AdvancedGameModesProps> = ({ onBackToMenu, onStartGame }) => {
  const handleModeSelect = (mode: GameModeConfig) => {
    onStartGame(mode);
  };

  return (
    <Container>
      <Header>
        <Title>🚀 Avancerade lägen</Title>
        <Subtitle>Välj ett specialläge för att starta</Subtitle>
      </Header>

      <Card>
        <GameModeVariants onModeSelect={handleModeSelect} />
      </Card>

      <Footer>
        <BackButton onClick={onBackToMenu}>⬅️ Till huvudmeny</BackButton>
      </Footer>
    </Container>
  );
};

export default AdvancedGameModes;
